import application_settings from '../applicationSettings';
import Event from './Event';

class SaveContactFormData extends Event {
    eventName = 'oms_saveContactFormData';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Save Contact Form Details
     * 
     * @param {string} data.client_id -  client_id
     * @param {array} data.more_info -  custom field data
     * 
     * @return void
     *  
     */
    eventFunction(data) {
        
            let clientId = data.client_id;
            let thisObj = this;
            let requestId = (data.request_id) ? data.request_id : '';
            let action = (data.action) ? data.action : '';
            // request data
            data.endPoint = application_settings.endPoints.saveContactForm;
            data.method = 'POST';
            data.canUsePublicAuth = false;
            data.client_id = clientId;
            data.data = {
                more_info : data.more_info
            };
    
            // send request
            this.sendRequest(data, function (response) {
                if (response) {
                    //format response data
                    let data = thisObj.formatResponseData(response);
    
                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
              }
            });
    
        }
}

export default SaveContactFormData;